import React from "react";
import { Datepicker } from "flowbite-react";
import { datePickerInLineTheme } from "@utils/datePickerTheme";

export default function FlowbiteDatepickerInLine({
  name,
  value,
  handleOnChange,
  handleOnBlur,
  className,
  errorMsg=null,
  ...restProps
}) {
  return (
    <Datepicker
      name={name}
      id={name}
      value={value}
      onChange={handleOnChange}
      onBlur={handleOnBlur}
      color="custom"
      theme={datePickerInLineTheme(errorMsg)}
      className={className}
      {...restProps}
    />
  );
}
